import { render, staticRenderFns } from "./NestedDetails.vue?vue&type=template&id=47369075&"
import script from "./NestedDetails.vue?vue&type=script&lang=js&"
export * from "./NestedDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports